import AcceptPayment from '../../screens/accept-payments/page';
import BankAccountDetails from '../../screens/bank-account-details/page';
import Home from '../../screens/introduction/page';
import MerchantKyc from '../../screens/merchant-kyc/page';
import MerchantRegistration from '../../screens/merchant-registration/page';
import PaymentLink from '../../screens/payment-link/page';
import ResponseCode from '../../screens/response-code/page';
import Subscription from '../../screens/subscription/page';
import TestPayment from '../../screens/test-payment/page';
import VirtualAccount from '../../screens/virtual-account/page';

const merchantOnboardingRoute = {
	label: 'MERCHANT ONBOARDING',
	content: [
		{
			path: '/',
			name: 'Introduction',
			component: <Home />,
		},
		{
			path: '/merchant-registration',
			name: 'Merchant Registration',
			component: <MerchantRegistration />,
		},
		{
			path: '/merchant-kyc',
			name: 'Merchant KYC',
			component: <MerchantKyc />,
		},
		{
			path: '/bank-account-details',
			name: 'Bank Account Details',
			component: <BankAccountDetails />,
		},
	],
};

const integratingSpay = {
	label: 'INTEGRATING SPAY',
	content: [
		{
			path: '/accept-payments',
			name: 'Accept Payments',
			component: <AcceptPayment />,
		},
		{
			path: '/payment-link',
			name: 'Payment Link',
			component: <PaymentLink />,
		},
		{
			path: '/response-code',
			name: 'Response Code',
			component: <ResponseCode />,
		},
		{
			path: '/test-payment',
			name: 'Test Payment',
			component: <TestPayment />,
		},
	],
};

const spayFeatures = {
	label: 'SPAY FEATURES',
	content: [
		{
			path: '/subscription',
			name: 'Subscription',
			component: <Subscription />,
		},
		{
			path: '/virtual-account',
			name: 'Virtual Account',
			component: <VirtualAccount />,
		},
	],
};

const Contact = {};

const GeneralRoute = [merchantOnboardingRoute, integratingSpay, spayFeatures];

export { GeneralRoute, Contact };
